import {useEffect, useState} from 'react';

// Module-scoped filter store, the same shape as the keyword store: filters are
// shared across sibling components (a filter drawer sets them, the table reads
// them), unlike sort state, which is one operator's current view and lives in
// component useState.
//
// These filters go to the SERVER — they are spread into the listExecutions
// `filter` variable and are part of the query key — so unlike the keyword they
// are not limited to the pages already fetched.
let globalFilters: Record<string, string> = {};
const filterListeners: Set<(filters: Record<string, string>) => void> = new Set();

const notifyFilterChange = (filters: Record<string, string>) => {
    globalFilters = filters;
    filterListeners.forEach(listener => listener(filters));
};

export const useExecutionsFilter = () => {
    const [filters, setFilters] = useState<Record<string, string>>(globalFilters);

    useEffect(() => {
        const listener = (newFilters: Record<string, string>) => {
            setFilters(newFilters);
        };
        filterListeners.add(listener);
        return () => {
            filterListeners.delete(listener);
        };
    }, []);

    const handleSetFilters = (newFilters: Record<string, string>) => {
        notifyFilterChange(newFilters);
    };

    const handleClearFilters = () => {
        notifyFilterChange({});
    };

    return {
        filters,
        handleSetFilters,
        handleClearFilters,
    };
};

// Test-only reset — see the note in useExecutionsSearchQuery.
export const resetExecutionsFilter = () => {
    notifyFilterChange({});
};
